import {gql} from '@apollo/client'

export const OTP_MUTATION = gql`
  mutation verifyWebAdminOtp(
    $countryCode: Int!
    $mobileNumber: MobileNumber!
    $otp: String!
    $type: pinType!
    $ipAddress: String!
    $userAgent: String
    $browserUniqueId: String!
    $browserName: String
  ) {
    verifyWebAdminOtp(
      countryCode: $countryCode
      mobileNumber: $mobileNumber
      otp: $otp
      type: $type
      deviceDetail: {
        ipAddress: $ipAddress
        userAgent: $userAgent
        browserUniqueId: $browserUniqueId
        browserName: $browserName
      }
    ) {
      userId
      businessProfileId
      systemRole
      isLinkedDoctor
      tokenType
      token
      role
      roleId
      profileData {
        firstName
        lastName
        email
        phone
        profilePhoto
      }
      userPermissions
      applicationSetting
      businessProfileRole
    }
  }
`

// isDoctorOwnDefaultPharmacy

export const WEB_ADMIN_LOGIN = gql`
  mutation WebAdminLogin(
    $mobileNumber: MobileNumber!
    $countryCode: Int!
    $ipAddress: String!
    $userAgent: String
    $browserUniqueId: String!
    $browserName: String
    $type: pinType!
  ) {
    webAdminLogin(
      webAdminLogin: {
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        deviceDetail: {
          ipAddress: $ipAddress
          userAgent: $userAgent
          browserUniqueId: $browserUniqueId
          browserName: $browserName
        }
        type: $type
      }
    ) {
      resendOtpTime
      otp
      pinLength
    }
  }
`

export const WEB_ADMIN_LOGIN_PROD = gql`
  mutation WebAdminLogin(
    $mobileNumber: MobileNumber!
    $countryCode: Int!
    $ipAddress: String!
    $userAgent: String
    $browserUniqueId: String!
    $browserName: String
    $type: pinType!
  ) {
    webAdminLogin(
      webAdminLogin: {
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        deviceDetail: {
          ipAddress: $ipAddress
          userAgent: $userAgent
          browserUniqueId: $browserUniqueId
          browserName: $browserName
        }
        type: $type
      }
    ) {
      resendOtpTime
      pinLength
    }
  }
`

export const RESEND_OTP = gql`
  mutation resendOtp($countryCode: Int!, $mobileNumber: MobileNumber!) {
    resendOtp(sendOtpInput: {countryCode: $countryCode, mobileNumber: $mobileNumber})
  }
`

export const GET_MPIN_LENGTH = gql`
  query getMpinLengthFromMobileNumber(
    $countryCode: Int!
    $mobileNumber: MobileNumber!
    $ipAddress: String!
    $userAgent: String
    $browserUniqueId: String!
    $browserName: String
    $deviceType: deviceType!
  ) {
    getMpinLengthFromMobileNumber(
      loginRegInput: {
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        deviceDetail: {
          deviceType: $deviceType
          ipAddress: $ipAddress
          userAgent: $userAgent
          browserUniqueId: $browserUniqueId
          browserName: $browserName
        }
      }
    ) {
      mpinLength
      enforceOtpLoginWeb
      enforceOtpLoginApp
    }
  }
`

export const LOGOUT = gql`
  mutation logoutSession($logoutType: logoutType!) {
    logoutSession(logoutType: $logoutType)
  }
`
